import {type NavigationGuardNext, type RouteLocationNormalized} from 'vue-router';
import {useWorkspaceStore} from "@shared/stores/workspace.store";
import {goToWorkspace} from "@shared/helpers";
import {AuthenticationNs} from "@shared/types";
import {useUserStore} from "@shared/stores/user.store";
import {useRegisterStore} from "@domains/auth/stores/register.store";

const getNext = (next: NavigationGuardNext, to: RouteLocationNormalized): void => {
    const workspaceStore = useWorkspaceStore();
    const workspaces = workspaceStore.workspaceList;
    switch (true) {
        // Faz 1.0: case bloklarına `{}` scope eklendi (no-case-declarations).
        case workspaces.length < 1: {
            const goToCreateNewWs = to.query.goToCreateWs;
            if (goToCreateNewWs && goToCreateNewWs === 'true') {
                const userStore = useUserStore();
                const registerStore = useRegisterStore();
                registerStore.registeredUserName = userStore.getUserName;
                next({name: 'CreateWorkspace'});
            } else {
                next({name: AuthenticationNs.AuthenticationRouteEnums.ExistingCreateWorkspaces});
            }
            break;
        }
        case workspaces.length === 1:
            goToWorkspace(workspaces[0], null, next);
            break;
        case workspaces.length > 1:
            next();
            break;
    }
};

export const existingWorkspacesResolver = async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext,
): Promise<void> => {
    const workspaceStore = useWorkspaceStore();
    workspaceStore.loadUserWorkspaceList().then(() => {
        getNext(next, to);
    })
};
